import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'

interface MemesIconProps {
    contextStyles?: string
    size?: number
    iconClassName?: string
    hoverStyles?: string
    selectedStyles?: string
}

// The [[ ]] meme-tag syntax, drawn lucide-style (24 viewBox, stroke 2).
export default function MemesIcon({
    contextStyles,
    hoverStyles,
    selectedStyles,
    size = 20,
    iconClassName,
}: MemesIconProps) {
    return (
        <div className={cn(styles.memesIconWrapper, contextStyles, hoverStyles, selectedStyles)}>
            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={cn(styles.memesIcon, iconClassName)}
            >
                <path d="M6 5H3v14h3" />
                <path d="M11 5H8v14h3" />
                <path d="M13 5h3v14h-3" />
                <path d="M18 5h3v14h-3" />
            </svg>
        </div>
    )
}
